import { useRef, useState, useEffect } from "react";
import { useHardCode, useAPI } from "../../hooks";
import {
  FacebookIcon,
  LinkedinIcon,
  TwitterIcon,
  WhatsappIcon,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import html2canvas from "html2canvas";
import { useAppContext } from "../../contexts";
import { Toast } from "..";

const IncentiveCertificate = ({ storeConfigState, productDetailsState }) => {
  const componentRef = useRef();
  const [sharerURL, setSharerURL] = useState(null);
  const { isInternalServerError, setIsInternalServerError } = useAppContext();
  const { UPLOAD_IMAGE_API, SOCIAL_API } = useAPI();
  const { SHOPIFY_SHOP_OBJECT, CURRENT_STORE_NAME, PURE_FEMALE_TRANSLATION } =
    useHardCode();
  const isPureFemale = SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.pure_female;
  const heading = isPureFemale
    ? PURE_FEMALE_TRANSLATION.incentive_certificate.heading
    : storeConfigState?.themeConfig?.be_a_climate_change_warrior;
  const desc = isPureFemale
    ? PURE_FEMALE_TRANSLATION.incentive_certificate.desc
    : storeConfigState?.themeConfig?.carbon_emission;
  const brand = "EcoReturns";
  const share = isPureFemale
    ? PURE_FEMALE_TRANSLATION.incentive_certificate.share
    : storeConfigState?.themeConfig?.share_and_encourage_others;
  const button = isPureFemale
    ? PURE_FEMALE_TRANSLATION.incentive_certificate.button
    : storeConfigState?.themeConfig?.generating_your_certificate;
  useEffect(() => {
    createACertificate();
  }, []);

  // Create Certificate
  const createACertificate = async () => {
    const canvas = await html2canvas(componentRef.current);
    const image = canvas.toDataURL("image/png", 1.0);

    try {
      const response = await fetch(UPLOAD_IMAGE_API, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          files: [image],
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (response.ok) {
        // Make an API Call to fetch sharing URL
        await fetchSharingURL(data[0]);
      }
    } catch (err) {
      setIsInternalServerError(true);
    }
  };

  async function fetchSharingURL(imageURL) {
    const storeURL = storeConfigState.baseURL;

    const caption = desc;

    const payload = {
      title: heading,
      image: imageURL,
      description: caption,
      type: "Article",
      url: storeURL,
    };

    try {
      const response = await fetch(SOCIAL_API, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (response.ok) {
        setSharerURL(`${process.env.REACT_APP_API_URL}` + data.url);
      }
    } catch (err) {
      setIsInternalServerError(true);
    }
  }

  return (
    <section className="incentivecertificate">
      {isInternalServerError && <Toast type="error" />}
      <div className="incentivecertificate__container">
        <div
          className="incentivecertificate__container__content"
          ref={componentRef}
        >
          <img
            className="incentivecertificate__container__certificate"
            src="assets/incentive-certificate.png"
          />
          <h3 className="incentivecertificate__container--subheading">
            {storeConfigState.storeName}
          </h3>
          <h3 className="incentivecertificate__container--subheading">&</h3>
          <h3 className="incentivecertificate__container--subheading">
            {brand}
          </h3>
        </div>
        <div className="incentivecertificate__container__actions">
          <div className="incentivecertificate__container__actions__header">
            {sharerURL ? (
              <p className="incentivecertificate__container__actions__header__text">
                {share}
              </p>
            ) : (
              <>
                <p className="incentivecertificate__container__actions__header__text">
                  {button}
                </p>
                <div
                  className="saara-spinner-border saara-spinner-border-sm saara-spinner-border-margin"
                  role="status"
                >
                  <span className="saara-visually-hidden"></span>
                </div>
              </>
            )}
          </div>
          {sharerURL && (
            <div className="incentivecertificate__container__actions__container">
              <div className="incentivecertificate__container__actions__container__item">
                <FacebookShareButton
                  url={sharerURL}
                  className="incentivecertificate__container__actions__container__item__link"
                >
                  <FacebookIcon size={40} borderRadius={10} />
                </FacebookShareButton>
                <LinkedinShareButton
                  url={sharerURL}
                  className="incentivecertificate__container__actions__container__item__link"
                >
                  <LinkedinIcon size={40} borderRadius={10} />
                </LinkedinShareButton>
                {/* <TwitterShareButton
                  url={sharerURL}
                  className="incentivecertificate__container__actions__container__item__link"
                >
                  <TwitterIcon size={40} borderRadius={10} />
                </TwitterShareButton>
                <WhatsappShareButton
                  url={sharerURL}
                  className="incentivecertificate__container__actions__container__item__link"
                >
                  <WhatsappIcon size={40} borderRadius={10} />
                </WhatsappShareButton> */}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export { IncentiveCertificate };
